import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openModalBottom } from '../../../actions/ui';
import { YlmRadio } from '../../../components/forms/YlmRadio';

// eslint-disable-next-line no-empty-character-class
const rx_live = /^[+-]?\d*(?:[]\d*)?$/;

export const Reservas = ({objEmpresa, setObjEmpresa, cambiado, guardar, cancelar}) => {
  const dispatch = useDispatch();
  const { colores } = useSelector(state => state.ui);
  const [customTimeSlot, setCustomTimeSlot] = useState('');
  const [isCustomSelected, setIsCustomSelected] = useState(false);

  const predefinedSlots = ['5','10','15','20','30','60'];
  const customActive = isCustomSelected || (!!objEmpresa?.intervaloTiempo && !predefinedSlots.includes(String(objEmpresa.intervaloTiempo)));

  useEffect(() => {
    const value = (objEmpresa && objEmpresa.intervaloTiempo != null) ? String(objEmpresa.intervaloTiempo) : '';
    if (value && !predefinedSlots.includes(value)) {
      setCustomTimeSlot(value);
      setIsCustomSelected(true);
    } else {
      setCustomTimeSlot('');
      setIsCustomSelected(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objEmpresa?.intervaloTiempo]);

  const changeFranja = ( newTime ) => {
    // console.log( objEmpresa );
    setObjEmpresa({ ...objEmpresa, intervaloTiempo: newTime });
    setIsCustomSelected(false);
  }

  const handleCustomTimeSlot = ( value ) => {
    if (!value) {
      setCustomTimeSlot('');
      return;
    }
    if (rx_live.test(value) && value.length < 4) {
      setCustomTimeSlot(value);
      const n = parseInt(value, 10);
      if (!Number.isNaN(n) && n >= 1 && n <= 180) {
        setObjEmpresa({ ...objEmpresa, intervaloTiempo: String(n) });
        setIsCustomSelected(true);
      } else {
        dispatch(openModalBottom({ text: ['El intervalo debe ser un entero entre 1 y 180'], timeOut: 3 }));
      }
    }
  }

  const selectCustomOption = () => {
    setIsCustomSelected(true);
    if (customTimeSlot && parseInt(customTimeSlot) > 0) {
      setObjEmpresa({ ...objEmpresa, intervaloTiempo: customTimeSlot });
    }
  }

  const horasAntesChange = ( value ) => {
    if( rx_live.test(value) && value.length < 3)
      setObjEmpresa({ ...objEmpresa, horasCancelacion: value });
  }

  const cancelacionChange = ( value ) => {
    setObjEmpresa({ ...objEmpresa, retornoApp: value });
  }
  
  const recogidaChange = ( value ) => {
    if( rx_live.test(value) && value.length < 3)
      setObjEmpresa({ ...objEmpresa, diasRecogida: value });
  }

  return (
    <div className='configuracion-wrapper'>
      <div className='header'>
        <h1 style={{color: colores.colorPrincipal}}>Reservas</h1>
        {
          cambiado &&
          <div className='botonera'>
            <button 
              className='btn btn-primary'
              style={{ color: colores.color6, backgroundColor: colores.colorPrincipal }}
              onClick={ guardar }
            >
              Aplicar
            </button>
            <button 
              className='btn btn-secondary'
              style={{ color: colores.colorPrincipal, backgroundColor: colores.color6 }}
              onClick={ cancelar }
            >
              Cancelar
            </button>
          </div>
        }
      </div>
      <div className='section franja'>
        <h3 style={{ color: colores.colorSecundario }}>Dividir franja horaria</h3>
        <h5>¿En qué unidades de tiempo (minutos) quieres que se muestre el tiempo disponible?</h5>
        <div className='franja-items'>
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '5' }
            clickFunction={ () => changeFranja('5') }
            text={`5'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '10' }
            clickFunction={ () => changeFranja('10') }
            text={`10'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '15' }
            clickFunction={ () => changeFranja('15') }
            text={`15'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '20' }
            clickFunction={ () => changeFranja('20') }
            text={`20'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '30' }
            clickFunction={ () => changeFranja('30') }
            text={`30'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ String(objEmpresa.intervaloTiempo) === '60' }
            clickFunction={ () => changeFranja('60') }
            text={`60'`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
        </div>
        <div className='custom-time-slot'>
          <div className='custom-option'>
            <span className={`label ${customActive ? 'active' : ''}`}>
              Personalizado:
            </span>
            <input 
              type='text'
              pattern="[0-9]{0,3}"
              placeholder="Ej: 45"
              className='custom-minutes-input'
              value={ customTimeSlot }
              onChange={ (e) => handleCustomTimeSlot( e.target.value )}
              onClick={ selectCustomOption }
            />
            <span className='minutes'>minutos</span>
          </div>
        </div>
      </div>
      {/* <div className='section horario'>
        <h3>Horario agenda</h3>
        <h5>El horario de tu agenda de reservas se rige por una de estas dos opciones:</h5>
        <div className='horario-items'>
          <div 
            className={`ylm-radio ${horario === 'profesionales' && 'active'}`}
            onClick={ () => setHorario('profesionales') }
          >
            <div className='radio-item'></div>
            <p>Horario profesionales</p>
          </div>
          <div 
            className={`ylm-radio ${horario === 'sucursales' && 'active'}`}
            onClick={ () => setHorario('sucursales') }
          >
            <div className='radio-item'></div>
            <p>Horario sucursales</p>
          </div>
        </div>
      </div> */}
      <div className='section cancelacion'>
        <h3 style={{ color: colores.colorSecundario }}>Cancelación reserva</h3>
        <h5>Tus clientes podrán cancelar una reserva hasta 
          <input 
            type='text'
            className='config-input-inline'
            pattern="[+-]?\d+(?:[.,]\d+)?"
            value={ objEmpresa.horasCancelacion }
            onChange= { (e) => horasAntesChange( e.target.value )}
          />
          horas antes</h5>
        <h5>En caso de cancelación de reserva en pagos por adelantado, se devolverá el importe a través de:</h5>
        <div className='cancelacion-items'>
          <YlmRadio
            active={ objEmpresa.retornoApp }
            clickFunction={ () => cancelacionChange( true ) }
            text={`App (quedará el importe almacenado en la cuenta de usuario)`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
          <YlmRadio
            active={ !objEmpresa.retornoApp }
            clickFunction={ () => cancelacionChange( false ) }
            text={`Forma de pago`}
            color={ colores.colorPrincipal }
            bgColor={ colores.colorSecundario }
          />
        </div>
      </div>
      <div className='section productos'>
        <h3 style={{ color: colores.colorSecundario }}>Productos</h3>
        <h5>Tus clientes tendrán un margen de 
          <input 
            type='text'
            className='config-input-inline'
            pattern="[+-]?\d+(?:[.,]\d+)?"
            value={ objEmpresa.diasRecogida }
            onChange= { (e) => recogidaChange( e.target.value )}
          />
           días para recoger su producto. Pasados esos días, el producto volverá a su venta.</h5>
      </div>
    </div>
  )
}
